import { lazy } from "react";
import { redirect, type RouteObject } from "react-router";

const LandingPage = lazy(() => import("./pages/LandingPage"));
const OnboardingPage = lazy(() => import("./pages/OnboardingPage"));
const AppHome = lazy(() => import("./pages/AppHome"));
const RoutinePage = lazy(() => import("./pages/RoutinePage"));
const SettingsPage = lazy(() => import("./pages/SettingsPage"));
const NotificationHistoryPage = lazy(() => import("./pages/NotificationHistoryPage"));
const GuidePage = lazy(() => import("./pages/GuidePage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));
const TermDetailPage = lazy(() => import("./pages/TermsPage").then((module) => ({ default: module.TermDetailPage })));
const AcceptInvitePage = lazy(() => import("./pages/AcceptInvitePage"));
const SupabaseAuthFallbackPage = lazy(() => import("./pages/SupabaseAuthFallbackPage"));
const KakaoAuthCallbackPage = lazy(() => import("./pages/KakaoAuthCallbackPage"));
const KakaoExternalBrowserPage = lazy(() => import("./pages/KakaoExternalBrowserPage"));
const AuthSignupConsentPage = lazy(() => import("./pages/AuthSignupConsentPage"));
const EmailAuthPage = lazy(() => import("./pages/EmailAuthPage"));
const PricingPage = lazy(() => import("./pages/PricingPage"));
const RefundPolicyPage = lazy(() => import("./pages/RefundPolicyPage"));
const AccountDeletionPage = lazy(() => import("./pages/AccountDeletionPage"));
const BillingPage = lazy(() => import("./pages/BillingPage"));
const BillingAccountPage = lazy(() => import("./pages/BillingAccountPage"));
const BillingSetupPage = lazy(() => import("./pages/BillingSetupPage"));
const WinbackEntryPage = lazy(() => import("./pages/WinbackEntryPage"));

export const appRoutes: RouteObject[] = [
  {
    path: "/",
    Component: LandingPage,
  },
  {
    path: "/pricing",
    Component: PricingPage,
  },
  {
    path: "/refund-policy",
    Component: RefundPolicyPage,
  },
  {
    path: "/account-deletion",
    Component: AccountDeletionPage,
  },
  {
    path: "/winback/entry",
    Component: WinbackEntryPage,
  },
  {
    path: "/review/billing",
    loader: () => redirect("/pricing"),
  },
  {
    path: "/onboarding",
    Component: OnboardingPage,
  },
  {
    path: "/terms",
    Component: TermsPage,
  },
  {
    path: "/terms/:key",
    Component: TermDetailPage,
  },
  {
    path: "/invite/:token",
    Component: AcceptInvitePage,
  },
  {
    path: "/auth/callback",
    Component: SupabaseAuthFallbackPage,
  },
  {
    path: "/auth/kakao/callback",
    Component: KakaoAuthCallbackPage,
  },
  {
    path: "/auth/kakao/browser",
    Component: KakaoExternalBrowserPage,
  },
  {
    path: "/auth/signup-consent",
    Component: AuthSignupConsentPage,
  },
  {
    path: "/auth/email",
    Component: EmailAuthPage,
  },
  {
    path: "/app",
    Component: AppHome,
    children: [
      { index: true, Component: RoutinePage },
      { path: "billing", Component: BillingPage },
      { path: "billing/account", Component: BillingAccountPage },
      { path: "billing/setup", Component: BillingSetupPage },
      { path: "settings", Component: SettingsPage },
      { path: "notifications", Component: NotificationHistoryPage },
      { path: "guide", Component: GuidePage },
    ],
  },
];
